var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLowerBody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 125 133",
    style: {
      enableBackground: "new 0 0 125 133"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.8,133c-1.1-0.6-2.3-1-3.2-1.8c-2.9-2.6-2.7-7.2,0.4-9.7c0.6-0.4,1.1-0.8,1.7-1.1 c9.1-5.4,18.2-10.9,27.3-16.3c0.9-0.6,1.5-1.2,1.7-2.2c1.5-6.1,3.1-12.1,4.7-18.2c0.1-0.5,0.1-1.3-0.2-1.7 c-2.3-3.1-2.9-6.6-1.9-10.3c2.6-9.9,5.1-19.8,7.7-29.6c2.4-8.9,10.8-13.9,19.8-11.7c1.8,0.4,3.5,0.9,5.3,1.4c3.9,1.1,6,4.2,5.2,8.1 c-0.5,2.7-1.3,5.4-2.1,8.4c-0.8-1.8-1.6-3.2-2.3-4.7c-0.7-1.5-1.4-2.9-2.4-4.3c0.3,1.4,0.5,2.8,0.8,4.1c1,5.3,2.1,10.5,3,15.7 c0.2,0.8,0.6,1.2,1.3,1.6c5.8,2.4,11.6,4.8,17.4,7.3c3.2,1.4,4.8,4.4,3.8,7.4c-1.1,3.4-4.6,5.1-8.1,3.6c-4.4-1.8-8.8-3.6-13.1-5.4 c-2.6-1.1-5.2-2.2-7.7-3.2c-2.6-1-4-2.8-4.5-5.5C71.8,57.5,70.4,50.2,69,43c0-0.2-0.1-0.4-0.4-0.6c-0.1,2.3-0.2,4.6-0.3,6.8 c-0.2,5.1-0.4,10.2-0.6,15.3c-0.2,4.7,2,8.3,6.2,10.2c5.5,2.7,11.3,4.9,17,7.3c2.8,1.2,5.5,2.4,8.4,3.5c0.8,0.3,1.3,0.8,1.5,1.7 c3.4,12.3,6.9,24.6,10.4,36.9c1.2,4.3-0.3,7-4.9,8.9c-0.8,0-1.6,0-2.3,0c-3.1-0.9-4.7-3.1-5.5-6.2c-3.1-11.3-6.3-22.5-9.5-33.7 c-0.2-0.8-0.5-1.2-1.4-1.3c-5.2-0.8-10.4-1.6-15.6-2.5c-2.8-0.5-5.6-0.9-8.4-1.3c-0.1,0.4-0.2,0.7-0.3,1c-1.7,6.3-3.3,12.7-4.9,19 c-0.6,2.5-1.9,4.2-4.1,5.5c-9.5,5.6-19,11.4-28.5,17.1c-1.5,0.9-3.1,1.6-4.7,2.4C20.3,133,19.5,133,18.8,133z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.3,26.2c-7,0-12.9-5.8-12.9-12.8c0-7,5.8-12.9,12.7-12.9c7.1,0,13,5.8,13,12.9 C99.1,20.3,93.3,26.1,86.3,26.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerBody);
export default __webpack_public_path__ + "static/media/lowerBody.c98169a6926e0d25394b18f3d8884c64.svg";
export { ForwardRef as ReactComponent };